import React, { Component } from 'react';
import FileManagement from './FileManagement';
import Constants from '../../common/constants/Constants';
import Store from '../../redux/Store';
import {
  getFilesFromBlob,
  deleteFileFromBlob,
  getReadOnlyBlobSasToken,
} from './FileManagement.actions';
import { showSnackbar } from '../../common/state/snackbar/Snackbar.actions';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import PageContainer from '../../common/components/Page/PageContainer';

import { connect } from 'react-redux';
import { withRouter } from '../../common/utils/NavigationWrapper';

class FileManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirm: '',
      isFetching: false,
    };
  }

  componentDidMount() {
    this.setState({ isFetching: true }, () => this._loadFiles());
  }

  componentDidUpdate(prevProps) {
    if (
      typeof this.props.transferProgressMessage !== 'undefined' &&
      JSON.stringify(prevProps.transferProgressMessage) !=
        JSON.stringify(this.props.transferProgressMessage)
    ) {
      this._handleTransferProgressMessage(this.props.transferProgressMessage);
    }
  }

  _handleTransferProgressMessage = (message) => {
    const { FileName, FileSize, BytesTransferred, Status } = JSON.parse(message.data);
    let newData = Object.assign([], this.state.data);
    let elIndex = newData.findIndex((file) => file.blobLink === FileName);
    if (elIndex === -1) {
      getFilesFromBlob(this.props.instrument.SerialNumber).then((res) => {
        this.setState({ data: res.body });
      });
    }

    let statusLabel = Status;
    if (Status === 'Transfer to instrument' || Status === 'Transfer from instrument') {
      const percentage = Math.round((BytesTransferred / FileSize) * 100);
      statusLabel = Status.concat(' ' + percentage + '%');
    }
    newData[elIndex] = {
      ...newData[elIndex],
      status: statusLabel,
    };
    this.setState({ data: newData });
  };

  _loadFiles = () => {
    getFilesFromBlob()
      .then((res) => {
        this.setState({ data: res.body, isFetching: false });
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to load files.',
          })
        );
      });
  };

  render() {
    return (
      <PageContainer pageName="file-management">
        <PermissionsCheck
          appliedToPage={true}
          permission={[PermissionsEnum.SEND_FILES, PermissionsEnum.RECEIVE_FILES]}
        >
          <FileManagement
            data={this.state}
            onClickDelete={this._onClickDelete}
            showConfirmDialog={this.state.showConfirmDialog}
            messageToConfirm={this.state.messageToConfirm}
            isFetching={this.state.isFetching}
            onClickDownload={this._onClickDownload}
          />
        </PermissionsCheck>
      </PageContainer>
    );
  }

  _onClickDelete = (blobLink, displayAddress) => {
    this.setState({
      messageToConfirm: `Are you sure you want to remove the file ${displayAddress} ?`,
      showConfirmDialog: {
        title: `Remove file`,
        show: true,
        action: () => this._onConfirmDeleteBlob(blobLink),
        cancel: this._onCancelDeleteBlob,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmDeleteBlob = (blobLink) => {
    deleteFileFromBlob(blobLink)
      .then((res) => {
        getFilesFromBlob().then((res) => {
          this.setState({
            data: res.body,
            messageToConfirm: '',
            showConfirmDialog: {
              show: false,
              action: () => {},
              cancel: () => {},
              disableMainAction: false,
            },
          });
        });
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
            message: 'File deleted successfully.',
          })
        );
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to delete the file. Please try again.',
          })
        );
      });
  };

  _onCancelDeleteBlob = () => {
    this.setState({
      messageToConfirm: '',
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
    });
  };

  _onClickDownload = (blobUrl) => {
    getReadOnlyBlobSasToken(blobUrl)
      .then((res) => {
        let token = res.body;
        let pathWithToken = blobUrl + token;
        var downloadWindow = window.open(pathWithToken);
        try {
          downloadWindow.focus();
        } catch (e) {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message:
                'Download blocked by browser. Add this site to your exception list and try again.',
            })
          );
        }
      })
      .catch((err) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to download the selected file.',
          })
        );
      });
  };
}

const mapStateToProps = (state) => ({
  transferProgressMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find((el) => el.type === 'FileTransferProgress')
      : null,
});

export default withRouter(connect(mapStateToProps)(FileManagementContainer));
